import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDebuggerTabPath } from './utils';
import { AppState } from '~store/modules';
import { tryCloseTab } from '~store/modules/root/thunks';
import { setSessions } from './reducer';

export const wipeDebuggerSessions = createAsyncThunk<
  void,
  void,
  {
    state: AppState;
  }
>('files/wipeDebuggerSessions', async (_, { getState, dispatch }) => {
  const { sessions } = getState().debugger;

  for (const { threadId } of sessions) {
    const path = getDebuggerTabPath(threadId);
    dispatch(tryCloseTab(path));
  }
});

export const removeDebuggerSessionsNotIn = createAsyncThunk<
  { staleThreadIds: number[] },
  { threadIds: number[] },
  { state: AppState }
>(
  'files/removeDebuggerSessionsNotIn',
  async (payload, { getState, dispatch }) => {
    const { threadIds } = payload;
    const { sessions } = getState().debugger;
    const staleThreadIds: number[] = [];
    const newSessions = sessions.filter((session) => {
      const isStillActive = threadIds.includes(session.threadId);
      if (!isStillActive) {
        staleThreadIds.push(session.threadId);
      }
      return isStillActive;
    });
    dispatch(setSessions(newSessions));
    return { staleThreadIds };
  },
);
